import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';
import './BlastsCSS/DialogStyles.css';

export default function DeleteBlastDialog({ open, onClose, onConfirm }) {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            PaperProps={{
                className: 'dialog-container'
            }}
        >
            <DialogTitle>
                <Typography 
                    component="div"
                    className="dialog-title inter-custom"
                >
                    Delete Blast
                </Typography>
            </DialogTitle>
            <DialogContent className="dialog-content">
                <Typography className="dialog-message">
                    Are you sure you want to delete this blast?
                </Typography>
            </DialogContent>
            <DialogActions className="dialog-actions">
                <Button 
                    onClick={onClose}
                    className="dialog-button dialog-button-small dialog-button-secondary inter-custom"
                >
                    Cancel
                </Button>
                <Button 
                    onClick={onConfirm}
                    className="dialog-button dialog-button-small dialog-button-primary inter-custom"
                    sx={{ 
                        backgroundColor: '#dc2626 !important', // Red color for delete
                        '&:hover': {
                            backgroundColor: '#dc2626 !important',
                            opacity: 0.9
                        }
                    }}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
} 